import React, { useEffect } from "react";
import { useState } from "react";
import TextField from "@material-ui/core/TextField";
import MuiAlert from "@material-ui/lab/Alert";
import Button from "@material-ui/core/Button";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  InputAdornment,
  Snackbar
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import api from "../api";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    width: "100%"
  },
  appBar: {
    position: "relative"
  },
  title: {
    marginLeft: "2rem",
    flex: 1,
    color: "white"
  },
  paper: {
    padding: "2rem",
    textAlign: "center"
  },
  checkedIcon: {
    width: 16,
    height: 16
  },
  checkbox: {
    padding: 0,
    paddingRight: "4px",
    marginLeft: "0px",
    marginRight: "8px",
    marginBottom: "0px"
  },
  option: {
    fontWeight: 600,
    fontSize: "0.75rem"
  },
  typography: {
    fontSize: "0.75rem"
  },
  select: {
    marginTop: "0",
    marginRight: "12px",
    padding: "0"
  },
  menu: {
    fontSize: "0.75rem"
  }
}));

const WorkOrderChecklist = ({ work_order_id }) => {
  const classes = useStyles();
  const types = [
    { id: 0, name: "Checklist de entrega" },
    { id: 1, name: "Checklist de devolución" },
    { id: 2, name: "Checklist de mantenimiento" }
  ];
  const state_types = ["Excelente", "Muy Bueno", "Bueno", "Regular", "Malo"];
  const [snackbar, setSnackbar] = useState({
    open: false,
    success_message: "",
    severity: "success"
  });
  const [workOrderChecklist, setWorkOrderChecklist] = useState({
    type: "",
    km: "",
    tier_status: "",
    interior_status: "",
    exterior_status: "",
    others_status: "",
    comments: "",
    maintenance_required: false,
    is_total_destruction: false
  });

  useEffect(() => {
    const token = localStorage.getItem("userToken");
    const getWorkOrderChecklist = async () => {
      await axios
        .get(api.work_order_checklists().get(work_order_id), {
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
        .then(response => {
          if (response.data) {
            if (response.data.is_total_destruction == 1)
              response.data.is_total_destruction = true;
            if (response.data.maintenance_required == 1)
              response.data.maintenance_required = true;

            setWorkOrderChecklist(response.data);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    };
    getWorkOrderChecklist();
  }, [work_order_id]);
  const handleSubmit = () => {
    var formData = new FormData();
    var url = api.work_order_checklists().post();
    formData.set("work_order_checklist[work_order_id]", work_order_id);
    formData.set(
      "work_order_checklist[type]",
      workOrderChecklist.type ? workOrderChecklist.type : ""
    );
    formData.set(
      "work_order_checklist[km]",
      workOrderChecklist.km ? workOrderChecklist.km : ""
    );
    formData.set(
      "work_order_checklist[tier_status]",
      workOrderChecklist.tier_status ? workOrderChecklist.tier_status : ""
    );
    formData.set(
      "work_order_checklist[interior_status]",
      workOrderChecklist.interior_status
        ? workOrderChecklist.interior_status
        : ""
    );
    formData.set(
      "work_order_checklist[exterior_status]",
      workOrderChecklist.exterior_status
        ? workOrderChecklist.exterior_status
        : ""
    );
    formData.set(
      "work_order_checklist[others_status]",
      workOrderChecklist.others_status ? workOrderChecklist.others_status : ""
    );
    formData.set(
      "work_order_checklist[comments]",
      workOrderChecklist.comments ? workOrderChecklist.comments : ""
    );
    formData.set(
      "work_order_checklist[maintenance_required]",
      workOrderChecklist.maintenance_required ? 1 : 0
    );
    formData.set(
      "work_order_checklist[is_total_destruction]",
      workOrderChecklist.is_total_destruction ? 1 : 0
    );
    formData.set(
      "work_order_checklist[vtv_due_date]",
      workOrderChecklist.vtv_due_date ? workOrderChecklist.vtv_due_date : ""
    );
    formData.set(
      "work_order_checklist[vtv_last_date]",
      workOrderChecklist.vtv_last_date ? workOrderChecklist.vtv_last_date : ""
    );
    formData.set(
      "work_order_checklist[service_last_date]",
      workOrderChecklist.service_last_date
        ? workOrderChecklist.service_last_date
        : ""
    );
    formData.set(
      "work_order_checklist[tiers_last_change]",
      workOrderChecklist.tiers_last_change
        ? workOrderChecklist.tiers_last_change
        : ""
    );
    formData.set(
      "work_order_checklist[docs_due_date]",
      workOrderChecklist.docs_due_date ? workOrderChecklist.docs_due_date : ""
    );
    formData.set(
      "work_order_checklist[warranty_due_date]",
      workOrderChecklist.warranty_due_date
        ? workOrderChecklist.warranty_due_date
        : ""
    );
    formData.set(
      "work_order_checklist[fire_extinguisher_due_date]",
      workOrderChecklist.fire_extinguisher_due_date
        ? workOrderChecklist.fire_extinguisher_due_date
        : ""
    );

    if (workOrderChecklist.id) {
      formData.set("work_order_checklist[id]", workOrderChecklist.id);
      formData.set("_method", "PATCH");
      url = api.work_order_checklists().patch(workOrderChecklist.id);
    }
    const token = localStorage.getItem("userToken");
    axios
      .post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        setSnackbar({
          open: true,
          success_message: "Checklist cargado con éxito",
          severity: "success"
        });
      })
      .catch(function(error) {
        var error_message = "Error al cargar el checklist";
        setSnackbar({
          open: true,
          success_message: error_message,
          severity: "warning"
        });
      });
  };

  const handleExport = async () => {
    const token = localStorage.getItem("userToken");
    axios
      .get(api.work_order_checklists().export(workOrderChecklist.id), {
        headers: { Authorization: `Bearer ${token}` },
        responseType: "blob"
      })
      .then(response => {
        const downloadUrl = window.URL.createObjectURL(
          new Blob([response.data])
        );
        const link = document.createElement("a");
        link.href = downloadUrl;
        const today = new Date();
        link.setAttribute(
          "download",
          "Reserva_" + today.toISOString() + ".pdf"
        ); //any other extension
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch(function(error) {
        console.log(error);
      });
  };

  return (
    <>
      <div className="row my-2 pb-4">
        <Snackbar
          open={snackbar.open}
          autoHideDuration={10000}
          onClose={() => {
            setSnackbar({ open: false });
          }}
        >
          <Alert
            onClose={() => {
              setSnackbar({ open: false });
            }}
            severity={snackbar.severity}
          >
            {snackbar.success_message}
          </Alert>
        </Snackbar>

        <TextField
          id="type"
          name="type"
          value={workOrderChecklist.type}
          onChange={event =>
            setWorkOrderChecklist(prev => ({
              ...prev,
              type: event.target.value
            }))
          }
          select
          margin="normal"
          className="m-0 p-0 col-md-3 pr-1"
          InputLabelProps={{
            shrink: true
          }}
          inputProps={{ style: { minWidth: 150, fontSize: "0.75rem" } }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="top">
                <Typography variant="caption">Tipo de checklist</Typography>
              </InputAdornment>
            ),
            style: { fontSize: "0.75rem" }
          }}
        >
          {types.map(option => (
            <MenuItem
              key={option.id}
              value={option.id}
              className={classes.menu}
              style={{ fontSize: "0.75rem" }}
            >
              {option.name}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          type="number"
          value={workOrderChecklist.km}
          onChange={value =>
            setWorkOrderChecklist({
              ...workOrderChecklist,
              km: value.target.value
            })
          }
          margin="normal"
          className="m-0 p-0 col-md-1 pr-1"
          InputLabelProps={{ shrink: true }}
          inputProps={{ style: { fontSize: "0.75rem" } }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Typography variant="caption">KM</Typography>
              </InputAdornment>
            )
          }}
        />
        <TextField
          value={workOrderChecklist.exterior_status}
          onChange={event =>
            setWorkOrderChecklist(prev => ({
              ...prev,
              exterior_status: event.target.value
            }))
          }
          margin="normal"
          className="m-0 p-0 col-md-3 pr-1"
          InputLabelProps={{ shrink: true }}
          inputProps={{ style: { minWidth: 150, fontSize: "0.75rem" } }}
          InputProps={{
            style: { fontSize: "0.75rem" },
            startAdornment: (
              <InputAdornment position="start">
                <Typography variant="caption">Estado exterior</Typography>
              </InputAdornment>
            )
          }}
          select
        >
          {state_types.map(option => (
            <MenuItem
              key={option}
              value={option}
              className={classes.menu}
              style={{ fontSize: "0.75rem" }}
            >
              {option}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          value={workOrderChecklist.interior_status}
          onChange={event =>
            setWorkOrderChecklist(prev => ({
              ...prev,
              interior_status: event.target.value
            }))
          }
          margin="normal"
          className="m-0 p-0 col-md-3 pr-1"
          InputLabelProps={{ shrink: true }}
          inputProps={{ style: { minWidth: 150, fontSize: "0.75rem" } }}
          InputProps={{
            style: { fontSize: "0.75rem" },
            startAdornment: (
              <InputAdornment position="start">
                <Typography variant="caption">Estado interior</Typography>
              </InputAdornment>
            )
          }}
          select
        >
          {state_types.map(option => (
            <MenuItem
              key={option}
              value={option}
              className={classes.menu}
              style={{ fontSize: "0.75rem" }}
            >
              {option}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          value={workOrderChecklist.tier_status}
          onChange={event =>
            setWorkOrderChecklist(prev => ({
              ...prev,
              tier_status: event.target.value
            }))
          }
          select
          margin="normal"
          className="m-0 p-0 col-md-3 pr-1"
          InputLabelProps={{ shrink: true }}
          inputProps={{ style: { minWidth: 150, fontSize: "0.75rem" } }}
          InputProps={{
            style: { fontSize: "0.75rem" },
            startAdornment: (
              <InputAdornment position="start">
                <Typography variant="caption">Estado cubiertas</Typography>
              </InputAdornment>
            )
          }}
        >
          {state_types.map(option => (
            <MenuItem
              key={option}
              value={option}
              className={classes.menu}
              style={{ fontSize: "0.75rem" }}
            >
              {option}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          value={workOrderChecklist.others_status}
          onChange={value =>
            setWorkOrderChecklist({
              ...workOrderChecklist,
              others_status: value.target.value
            })
          }
          margin="normal"
          className="m-0 p-0 col-md-3 pr-1"
          InputLabelProps={{ shrink: true }}
          inputProps={{ style: { minWidth: 150, fontSize: "0.75rem" } }}
          InputProps={{
            style: { fontSize: "0.75rem" },
            startAdornment: (
              <InputAdornment position="start">
                <Typography variant="caption">Estado otros</Typography>
              </InputAdornment>
            )
          }}
        />
        {workOrderChecklist.type === 1 && (
          <div className="col-md-12 pl-0">
            <FormControlLabel
              control={
                <Checkbox
                  checked={workOrderChecklist.maintenance_required}
                  onChange={() => {
                    setWorkOrderChecklist(prev => ({
                      ...prev,
                      maintenance_required: !workOrderChecklist.maintenance_required
                    }));
                  }}
                />
              }
              label={
                <Typography variant="caption">
                  Requiere mantenimiento?
                </Typography>
              }
              className={classes.checkbox}
            />
          </div>
        )}
        {workOrderChecklist.type === 1 && (
          <div className="col-md-12 pl-0">
            <FormControlLabel
              control={
                <Checkbox
                  checked={workOrderChecklist.is_total_destruction}
                  onChange={() => {
                    setWorkOrderChecklist(prev => ({
                      ...prev,
                      is_total_destruction: !workOrderChecklist.is_total_destruction
                    }));
                  }}
                />
              }
              label={
                <Typography variant="caption">Destrucción total?</Typography>
              }
              className={classes.checkbox}
            />
          </div>
        )}

        <TextField
          fullWidth
          value={workOrderChecklist.comments}
          onChange={value =>
            setWorkOrderChecklist({
              ...workOrderChecklist,
              comments: value.target.value
            })
          }
          margin="normal"
          className="m-0 p-0 pr-1 col-md-12"
          InputLabelProps={{ shrink: true }}
          inputProps={{ style: { minWidth: 150, fontSize: "0.75rem" } }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Typography variant="caption">Comentarios</Typography>
              </InputAdornment>
            )
          }}
          multiline
        />
        {workOrderChecklist.type === 2 && (
          <>
            <TextField
              type="date"
              value={workOrderChecklist.vtv_due_date}
              onChange={value =>
                setWorkOrderChecklist({
                  ...workOrderChecklist,
                  vtv_due_date: value.target.value
                })
              }
              margin="normal"
              className="m-0 p-0 col-md-3 pr-1"
              InputLabelProps={{ shrink: true }}
              inputProps={{ style: { fontSize: "0.75rem" } }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption">VTV vencimiento</Typography>
                  </InputAdornment>
                )
              }}
            />
            <TextField
              type="date"
              value={workOrderChecklist.vtv_last_date}
              onChange={value =>
                setWorkOrderChecklist({
                  ...workOrderChecklist,
                  vtv_last_date: value.target.value
                })
              }
              margin="normal"
              className="m-0 p-0 col-md-3 pr-1"
              InputLabelProps={{ shrink: true }}
              inputProps={{ style: { fontSize: "0.75rem" } }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption">VTV última</Typography>
                  </InputAdornment>
                )
              }}
            />
            <TextField
              type="date"
              value={workOrderChecklist.service_last_date}
              onChange={value =>
                setWorkOrderChecklist({
                  ...workOrderChecklist,
                  service_last_date: value.target.value
                })
              }
              margin="normal"
              className="m-0 p-0 col-md-3 pr-1"
              InputLabelProps={{ shrink: true }}
              inputProps={{ style: { fontSize: "0.75rem" } }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption">Service última</Typography>
                  </InputAdornment>
                )
              }}
            />
            <TextField
              type="date"
              value={workOrderChecklist.tiers_last_change}
              onChange={value =>
                setWorkOrderChecklist({
                  ...workOrderChecklist,
                  tiers_last_change: value.target.value
                })
              }
              margin="normal"
              className="m-0 p-0 col-md-3 pr-1"
              InputLabelProps={{ shrink: true }}
              inputProps={{ style: { fontSize: "0.75rem" } }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption">Cubiertas última</Typography>
                  </InputAdornment>
                )
              }}
            />
            <TextField
              type="date"
              value={workOrderChecklist.docs_due_date}
              onChange={value =>
                setWorkOrderChecklist({
                  ...workOrderChecklist,
                  docs_due_date: value.target.value
                })
              }
              margin="normal"
              className="m-0 p-0 col-md-3 pr-1"
              InputLabelProps={{ shrink: true }}
              inputProps={{ style: { fontSize: "0.75rem" } }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption">
                      Documentación vencimiento
                    </Typography>
                  </InputAdornment>
                )
              }}
            />
            <TextField
              type="date"
              value={workOrderChecklist.warranty_due_date}
              onChange={value =>
                setWorkOrderChecklist({
                  ...workOrderChecklist,
                  warranty_due_date: value.target.value
                })
              }
              margin="normal"
              className="m-0 p-0 col-md-3 pr-1"
              InputLabelProps={{ shrink: true }}
              inputProps={{ style: { fontSize: "0.75rem" } }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption">
                      Garantía vencimiento
                    </Typography>
                  </InputAdornment>
                )
              }}
            />
            <TextField
              type="date"
              value={workOrderChecklist.fire_extinguisher_due_date}
              onChange={value =>
                setWorkOrderChecklist({
                  ...workOrderChecklist,
                  fire_extinguisher_due_date: value.target.value
                })
              }
              margin="normal"
              className="m-0 p-0 col-md-3 pr-1"
              InputLabelProps={{ shrink: true }}
              inputProps={{ style: { fontSize: "0.75rem" } }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption">
                      Matafuego vencimiento
                    </Typography>
                  </InputAdornment>
                )
              }}
            />
          </>
        )}
      </div>

      <div className="row mt-2">
        <Button
          variant="contained"
          color="primary"
          size="small"
          style={{ fontSize: "0.75rem" }}
          onClick={e => {
            handleSubmit(e);
          }}
        >
          {workOrderChecklist.id ? "Guardar" : "Cargar"}
        </Button>
        <Button
          variant="contained"
          color="default"
          size="small"
          style={{ fontSize: "0.75rem", marginLeft: "1rem" }}
          onClick={e => {
            handleExport();
          }}
        >
          Exportar
        </Button>
      </div>
    </>
  );
};

export default WorkOrderChecklist;
